import React, { useState, useEffect } from "react";
import {
  TableContainer,
  Paper,
  Typography,
  Box,
  RadioGroup,
  Radio,
  FormControlLabel,
  TextField,
} from "@mui/material";

import { set } from "lodash";
import {
  validateNumberInput,
  validatePercentageInput,
} from "../../../../utils/validateFields";

function TableData({
  columnWidth,
  heading,
  columnValue,
  title,
  topHeading,
  topheader,
  formValues,
  setErrors,
  errorsindex,
  setFormValues,
  setRowIndex,
  errors,
  disabled,
  placehold,
}) {
  const [columnArray, setColumnArray] = useState([]);

  useEffect(() => {
    const columnLength = columnWidth.split(" ");
    setColumnArray(columnLength);
  }, [columnWidth]);

  const getNestedValue = (obj, path) => {
    return path.split(".").reduce((acc, part) => acc && acc[part], obj);
  };

  const calculatePercentages = (male, female, total) => {
    if (total === 0) {
      return { malePercentage: 0, femalePercentage: 0 };
    }
    return {
      malePercentage: (male / total) * 100,
      femalePercentage: (female / total) * 100,
    };
  };

  const handleChangeRadio = ({ target: { name, value } }) => {
    setFormValues((prev) => {
      const keys = name.split("."); // Assuming `name` is a dot-separated string
      const updatedForm = { ...prev };

      let current = updatedForm;
      keys.forEach((key, index) => {
        if (index === keys.length - 1) {
          current[key] = value; // Update the specific field
        } else {
          current[key] = { ...current[key] };
          current = current[key];
        }
      });

      return updatedForm;
    });
  };

  useEffect(() => {
    let newErrors = {};

    columnValue.forEach((item, rowIndex) => {
      if (
        item.value &&
        ![
          "retirementBenefits.currentFinancialYear.others",
          "retirementBenefits.previousFinancialYear.others",
        ].includes(item.key)
      ) {
        heading.slice(1).forEach((headings) => {
          const name = `${item.key}.${headings.key}`;
          newErrors[name] = {
            rowIndex,
            message: "", // Initialize with empty error message
          };
        });
      }
    });

    // Preserve previous errors instead of overriding them

    if (setRowIndex) {
      setRowIndex((prevIndex) => ({
        ...prevIndex,
        ...newErrors,
      }));
    }
  }, []);

  const handleChange = (e, type) => {
    const { name, value } = e.target;
    console.log(name, "name");

    // Clear validation error for this specific field when user starts typing
    if (errors && Array.isArray(errors)) {
      const keys = name.split(".");
      const mainKey = keys[0];
      const subKey = keys.length > 3 ? `${keys[1]}.${keys[2]}` : keys[1];
      const fieldName = keys[keys.length - 1];

      // Find and remove error for this specific field
      const updatedErrors = errors.filter((error) => {
        // Remove error if it matches the current field being edited
        return !(error.subkey === subKey && error.fieldName === fieldName);
      });

      if (updatedErrors.length !== errors.length) {
        setErrors(updatedErrors);
      }
    }

    if (type === "percentage" && !validatePercentageInput(value)) return;
    // if (type==="number" && !/^\d*$/.test(value)) return; // Allow only numeric values

    if (!validateNumberInput(value)) return;

    setFormValues((prevState) => {
      if (!prevState) return {};
      const keys = name.split(".");
      const updatedData = structuredClone(prevState);

      let currentLevel = updatedData;
      for (let i = 0; i < keys.length - 1; i++) {
        if (!currentLevel[keys[i]]) {
          currentLevel[keys[i]] = {};
        }
        currentLevel = currentLevel[keys[i]];
      }

      // Update value
      currentLevel[keys[keys.length - 1]] = value ? Number(value) : "";

      // Ensure `total`, `male`, and `female` exist before calculations
      const totalmaleEmployees =
        updatedData?.[keys[0]]?.maleEmployees?.[keys[1]] || 0;
      const totalfemaleEmployees =
        updatedData?.[keys[0]]?.femaleEmployees?.[keys[1]] || 0;

      const maleCount = currentLevel?.male || 0;
      const femaleCount = currentLevel?.female || 0;
      // const maxAllowedTotal = maleCount >0 + femaleCount>0;

      // let maxAllowedTotal =  currentLevel?.male  + currentLevel?.female;
      const newValue =
        keys[keys.length - 1] === "male"
          ? updatedData?.[keys[0]]?.maleEmployees?.[keys[1]]
          : updatedData?.[keys[0]]?.femaleEmployees?.[keys[1]] || 0;

      // Calculate percentages
      if ("malePercentage" in currentLevel) {
        currentLevel.malePercentage =
          totalmaleEmployees > 0
            ? ((maleCount / totalmaleEmployees) * 100).toFixed(2)
            : 0;
        if (currentLevel.male > totalmaleEmployees) {
          console.warn("❌ Female count exceeded the total employees!");

          // ✅ Set error message for female count
          setErrors((prevErrors) => {
            let newErrors = { ...prevErrors };

            Object.keys(errorsindex).forEach((errorKey) => {
              const nestedKeys = errorKey.split(".");
              const lastKey = keys[keys.length - 1]; // ✅ Extract last key
              const mainKey = nestedKeys[0]; // ✅ Always the first key
              const subKey =
                keys.length > 3 ? `${keys[1]}.${keys[2]}` : keys[1];

              // ✅ Extract row index dynamically
              const rowIndex =
                errorsindex[
                  keys.length > 3
                    ? `${keys[0]}.${keys[1]}.${keys[2]}.${keys[3]}`
                    : `${keys[0]}.${keys[1]}.${keys[2]}`
                ]?.rowIndex || "-";

              // ✅ Only update if mainKey === nestedKeys[0]
              if (mainKey === keys[0]) {
                // ✅ Reset previous messages for this mainKey
                newErrors[mainKey] = [];

                newErrors[mainKey].push({
                  subkey: subKey,
                  fieldName: lastKey,
                  rowIndex: rowIndex, // ✅ Ensures only this row's error is displayed
                  message: "Exceeded the value required field", // ✅ Always set the latest message
                });

                // ✅ Restrict user input by resetting the field to its previous valid value
                console.warn("❌ Input exceeded the allowed limit!");
              }
            });
            return newErrors; // ✅ Correctly return updated errors
          });
          return prevState;
        } else {
          // ✅ Remove error when the input is valid
          setErrors((prevErrors) => {
            let newErrors = { ...prevErrors };
            delete newErrors.female;
            return newErrors;
          });
        }
      }

      if ("femalePercentage" in currentLevel) {
        currentLevel.femalePercentage =
          totalfemaleEmployees > 0
            ? ((currentLevel.female / totalfemaleEmployees) * 100).toFixed(2)
            : 0;

        if (currentLevel.female > totalfemaleEmployees) {
          console.warn("❌ Female count exceeded the total employees!");

          // ✅ Set error message for female count
          setErrors((prevErrors) => {
            let newErrors = { ...prevErrors };

            Object.keys(errorsindex).forEach((errorKey) => {
              const nestedKeys = errorKey.split(".");
              const lastKey = keys[keys.length - 1]; // ✅ Extract last key
              const mainKey = nestedKeys[0]; // ✅ Always the first key
              const subKey =
                keys.length > 3 ? `${keys[1]}.${keys[2]}` : keys[1];

              // ✅ Extract row index dynamically
              const rowIndex =
                errorsindex[
                  keys.length > 3
                    ? `${keys[0]}.${keys[1]}.${keys[2]}.${keys[3]}`
                    : `${keys[0]}.${keys[1]}.${keys[2]}`
                ]?.rowIndex || "-";

              // ✅ Only update if mainKey === nestedKeys[0]
              if (mainKey === keys[0]) {
                // ✅ Reset previous messages for this mainKey
                newErrors[mainKey] = [];

                newErrors[mainKey].push({
                  subkey: subKey,
                  fieldName: lastKey,
                  rowIndex: rowIndex, // ✅ Ensures only this row's error is displayed
                  message: "Exceeded the value required field", // ✅ Always set the latest message
                });

                // ✅ Restrict user input by resetting the field to its previous valid value
                console.warn("❌ Input exceeded the allowed limit!");
              }
            });
            console.log("Updated Errors:", newErrors);
            return newErrors; // ✅ Correctly return updated errors
          });
          return prevState;
        } else {
          // ✅ Remove error when the input is valid
          setErrors((prevErrors) => {
            let newErrors = { ...prevErrors };
            delete newErrors.female;
            return newErrors;
          });
        }
      }
      let lastPreviousKeys = [];
      let tempData = updatedData;
      for (let i = 0; i < keys.length - 1; i++) {
        if (tempData?.[keys[i]]) {
          if (keys.length === 3) {
            // If only 3 keys, store the first key
            lastPreviousKeys.push(Object.keys(tempData[keys[i]]));
          } else if (keys.length >= 4) {
            // If 4 or more keys, store the second key and last-to-previous key
            lastPreviousKeys.push(Object.keys(tempData[keys[i]]));
          }

          tempData = tempData[keys[i]]; // Move deeper
        } else {
          break;
        }
      }

      const mainKey = keys.length > 3 ? `${keys[0]}.${keys[1]}` : keys[0];

      if (keys.length > 3 && keys[0] !== "returnAndRetentionParentalLeave") {
        const [firstKey, secondKey] = keys;
        if (
          updatedData[firstKey]?.[secondKey] &&
          lastPreviousKeys[1].includes("Total")
        ) {
          updatedData[firstKey][secondKey].total = calculateTotalEmployees(
            updatedData[firstKey][secondKey]
          );
        }
      } else if (keys[0] === "returnAndRetentionParentalLeave") {
        const [firstKey, secondKey] = keys;

        if (
          updatedData[firstKey]?.[secondKey] &&
          lastPreviousKeys[1].includes("total")
        ) {
          updatedData[firstKey][secondKey].Total = calculateReturnAndRetention(
            updatedData[firstKey][secondKey]
          );
        }
      } else {
        if (updatedData[mainKey] && lastPreviousKeys[0].includes("Total")) {
          updatedData[mainKey].total = calculateTotalEmployees(
            updatedData[mainKey]
          );
        }
      }

      return updatedData;
    });
  };

  const calculateTotalEmployees = (data) => {
    ["permanentEmployees", "otherEmployees"].forEach((category) => {
      if (data) {
        let totalMale = 0;
        let totalFemale = 0;

        Object.keys(data).forEach((benefitType) => {
          if (benefitType !== "Total") {
            // Exclude Total itself from calculations
            const benefit = data[benefitType];

            if (benefit && typeof benefit === "object") {
              totalMale += Number(benefit.male || 0);
              totalFemale += Number(benefit.female || 0);
            }
          }
        });

        // ✅ Store calculated values in the respective Total object
        data.Total.male = totalMale;
        data.Total.female = totalFemale;

        // ✅ Calculate percentages
        const totalEmployees = totalMale + totalFemale;
        data.Total.malePercentage =
          totalEmployees > 0
            ? ((totalMale / totalEmployees) * 100).toFixed(2)
            : "0";

        data.Total.femalePercentage =
          totalEmployees > 0
            ? ((totalFemale / totalEmployees) * 100).toFixed(2)
            : "0";
      }
    });
  };

  const calculateReturnAndRetention = (data) => {
    ["permanentEmployees", "permanentWorkers"].forEach((category) => {
      if (data) {
        let totalReturnToWork = 0,
          totalRetention = 0;

        Object.keys(data).forEach((group) => {
          if (group !== "total") {
            const groupData = data[group];

            if (groupData && typeof groupData === "object") {
              totalReturnToWork += Number(groupData.returnToWorkRate || 0) / 2;
              totalRetention += Number(groupData.retentionRate || 0) / 2;
            }
          }
        });

        if (!data.total) {
          data.total = { returnToWorkRate: "", retentionRate: "" };
        }

        // data.total = {
        //   returnToWorkRate: totalReturnToWork,
        //   retentionRate: totalRetention,
        // };
        data.total.returnToWorkRate = totalReturnToWork;
        data.total.retentionRate = totalRetention;
      }
    });
  };

  return (
    <Box sx={{ minWidth: 650 }}>
      <Typography
        variant="h6"
        sx={{
          textDecoration: "underline",
          textTransform: "Capitalize",
          fontWeight: "bold",
          margin: "15px 0",
        }}
      >
        {topheader}
      </Typography>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: "bold", margin: "15px 0" }}
        gutterBottom
      >
        {topHeading}
      </Typography>
      <Typography
        sx={{ marginBottom: "0.5rem", fontWeight: "bold", marginTop: "2rem" }}
        variant="body1"
        gutterBottom
      >
        {title}
      </Typography>
      <TableContainer
        component={Paper}
        sx={{ maxWidth: "100%", borderRadius: "10px", overflow: "hidden" }}
      >
        <Box>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: columnWidth,
              background: " #1C486B",
              borderBottom: "1px solid #ddd",
              borderTop: "1px solid #ddd",
            }}
          >
            {heading.map((item) => {
              return (
                <Typography
                  sx={{
                    height: "100%",
                    // fontWeight: "bold",
                    padding: "8px 12px",
                    color: "#FFFFFF",
                    paddingY: "10px",
                    borderRight: "1px solid #DBDBDB ",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  {item.title}
                </Typography>
              );
            })}
          </Box>

          {columnValue.map((item, rowIndex) => {
            if (item.value) {
              const isTotalRow = item.value.includes("Total"); // Check if the row is a Total row
              console.log(item?.value, "value1");
              return (
                <Box
                  key={item._id}
                  sx={{
                    display: "grid",
                    gridTemplateColumns: columnWidth,
                    borderBottom: "1px solid #ddd",
                    justifyContent: "center",
                  }}
                >
                  {/* Render Typography for the row */}
                  {item.type === "Optional" ? (
                    (() => {
                      // Safely extract key parts
                      const keyParts = item.key?.split(".");
                      const [mainKey, subKey, fieldKey] = keyParts || [];

                      const value =
                        formValues?.[mainKey]?.[subKey]?.[fieldKey]?.[
                          item.OptionalKey
                        ] ?? "";

                      return (
                        <TextField
                          variant="standard"
                          disabled={disabled || isTotalRow}
                          sx={{
                            borderRight: "1px solid #DBDBDB",
                            padding: "8px 12px",
                            "& .MuiInputBase-root": {
                              padding: 0, // Align with grid cells
                            },
                          }}
                          name={`${item.key}.${item.OptionalKey}`}
                          value={value}
                          onChange={(e) => {
                            const { name, value } = e.target;
                            const keys = name.split(".");
                            const [
                              mainKey,
                              subKey,
                              fieldKey,
                              differentlyAbledKey,
                            ] = keys;
                            console.log(keys, "keys");
                            setFormValues((prevState) => ({
                              ...prevState,
                              [mainKey]: {
                                ...prevState[mainKey],
                                [subKey]: {
                                  ...prevState[mainKey]?.[subKey],
                                  [fieldKey]: {
                                    ...prevState[mainKey]?.[subKey]?.[fieldKey],
                                    [differentlyAbledKey]: value,
                                  },
                                },
                              },
                            }));
                          }}
                          placeholder="Others - Please Specify"
                          InputProps={{ disableUnderline: true }}
                          fullWidth
                          size="small"
                        />
                      );
                    })()
                  ) : (
                    <Typography
                      sx={{
                        borderRight: "1px solid #DBDBDB",
                        fontSize: "15px",
                        padding: "10px",
                      }}
                    >
                      {item.value}
                    </Typography>
                  )}
                  {heading.length > 0 &&
                    heading.slice(1).map((headings, index) => {
                      const differentlyAbled = item.key
                        ?.toLowerCase()
                        .includes("differentlyabled");
                      const turnoverRate = item.key?.includes("turnoverRate");
                      const wellBeingMeasures =
                        item.key?.includes("wellBeingMeasures");
                      const wellBeingWorkers =
                        item.key?.includes("wellBeingWorkers");
                      const retirementBenefits =
                        item.key?.includes("retirementBenefits");
                      const returnAndRetentionParentalLeave =
                        item.key?.includes("returnAndRetentionParentalLeave");
                      const performanceAndCareerReviews = item.key?.includes(
                        "performanceAndCareerReviews"
                      );
                      const name = `${item.key}.${headings.key}`;

                      // Split the name into parts using '.' as a delimiter
                      const matchResult = name.split(".");

                      // Ensure the split result is valid
                      if (matchResult.length < 3) {
                        // console.error(`Invalid name format: ${name}`);
                        return null; // Skip this iteration if the name format is invalid
                      }

                      const [
                        mainKey,
                        subKey,
                        fieldKey,
                        differentlyAbledKey,
                        retirementBenefitsKey,
                      ] = matchResult;
                      console.log(
                        mainKey,
                        subKey,
                        fieldKey,
                        differentlyAbledKey,
                        retirementBenefitsKey,
                        "Field Name"
                      );
                      // const isPercentage = headings.title.includes("%");
                      const isPercentage =
                        headings.key !== "employeesCovered" &&
                        headings.key !== "workersCovered" &&
                        headings.title.includes("%");
                      // const isTotal = headings.title.includes("Total" !=="Total Employees");
                      const isTotal =
                        /Total(?! Employees || ?! No. of Employees)/.test(
                          headings.title
                        );
                      const disable =
                        isPercentage || isTotal || disabled || isTotalRow;
                      let value = "";

                      if (
                        (fieldKey === "maternityBenefits" &&
                          differentlyAbledKey === "male") ||
                        (fieldKey === "paternityBenefits" &&
                          differentlyAbledKey === "female")
                      ) {
                        value = "N/A";
                      } else {
                        value =
                          differentlyAbled ||
                          turnoverRate ||
                          wellBeingMeasures ||
                          wellBeingWorkers ||
                          returnAndRetentionParentalLeave ||
                          performanceAndCareerReviews
                            ? formValues?.[mainKey]?.[
                                mainKey === "wellBeingMeasures" ||
                                mainKey === "wellBeingWorkers" ||
                                mainKey === "returnAndRetentionParentalLeave" ||
                                mainKey === "turnoverRate"
                                  ? subKey
                                  : subKey.toLowerCase()
                              ]?.[
                                mainKey === "wellBeingMeasures" ||
                                mainKey === "wellBeingWorkers" ||
                                mainKey === "returnAndRetentionParentalLeave" ||
                                mainKey === "turnoverRate"
                                  ? fieldKey
                                  : fieldKey?.toLowerCase()
                              ]?.[
                                mainKey === "wellBeingMeasures" ||
                                mainKey === "wellBeingWorkers" ||
                                mainKey === "returnAndRetentionParentalLeave" ||
                                mainKey === "performanceAndCareerReviews" ||
                                mainKey === "turnoverRate"
                                  ? differentlyAbledKey
                                  : differentlyAbledKey?.toLowerCase()
                              ]
                            : retirementBenefits
                            ? formValues?.[mainKey]?.[
                                mainKey === "retirementBenefits" ||
                                mainKey === "performanceAndCareerReviews"
                                  ? subKey
                                  : subKey.toLowerCase()
                              ]?.[
                                mainKey === "retirementBenefits" ||
                                mainKey === "performanceAndCareerReviews"
                                  ? fieldKey
                                  : fieldKey?.toLowerCase()
                              ]?.[
                                mainKey === "retirementBenefits" ||
                                mainKey === "performanceAndCareerReviews"
                                  ? differentlyAbledKey
                                  : differentlyAbledKey?.toLowerCase()
                              ] ?? ""
                            : formValues?.[mainKey]?.[
                                mainKey === "womenRepresentation"
                                  ? subKey
                                  : subKey.toLowerCase()
                              ]?.[
                                mainKey === "womenRepresentation"
                                  ? fieldKey
                                  : fieldKey?.toLowerCase()
                              ] ?? "";
                      }

                      console.log(value, "value1");
                      return (
                        <>
                          {headings.type === "boolean" ? (
                            <RadioGroup
                              disabled={disabled}
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "0px",
                                padding: "0px 5px",
                              }}
                              // defaultValue="Yes" // Set the default selected value
                              value={
                                (mainKey === "retirementBenefits" &&
                                  formValues?.[mainKey]?.[subKey]?.[fieldKey]
                                    ?.deductedDeposited) ||
                                ""
                              }
                              name={name}
                              onChange={(e) =>
                                handleChangeRadio({
                                  target: {
                                    name,
                                    value: e.target.value,
                                  },
                                })
                              }
                            >
                              {["Yes", "No", "N/A"].map((item, index) => (
                                <FormControlLabel
                                  key={index}
                                  value={item}
                                  control={<Radio disabled={disabled} />}
                                  label={item}
                                />
                              ))}
                            </RadioGroup>
                          ) : (
                            <TextField
                              key={index} // Adding a key for mapping
                              variant="standard"
                              disabled={
                                (fieldKey === "maternityBenefits" &&
                                  differentlyAbledKey === "male") ||
                                (fieldKey === "paternityBenefits" &&
                                  differentlyAbledKey === "female") ||
                                disable
                              }
                              sx={{
                                backgroundColor:
                                  isPercentage || isTotal || isTotalRow
                                    ? "#EFEFEF"
                                    : "",
                                borderRight: "1px solid #DBDBDB",
                                padding: "8px 12px",
                                "& .MuiInputBase-root": {
                                  padding: 0, // Align with grid cells
                                },
                              }}
                              name={name}
                              type="text"
                              InputProps={{ disableUnderline: true }}
                              fullWidth
                              size="small"
                              value={value}
                              placeholder={
                                placehold
                                  ? placehold
                                  : isTotal
                                  ? "Total"
                                  : isPercentage
                                  ? "%"
                                  : "Enter Number"
                              }
                              onChange={
                                !isTotalRow
                                  ? (e) => {
                                      if (
                                        mainKey ===
                                        "returnAndRetentionParentalLeave"
                                      ) {
                                        if (Number(e.target.value) > 100)
                                          return;
                                      }
                                      handleChange(
                                        e,
                                        headings?.type
                                          ? headings?.type
                                          : "number"
                                      );
                                    }
                                  : undefined
                              }
                            />
                          )}
                        </>
                      );
                    })}
                </Box>
              );
            }
          })}
        </Box>
      </TableContainer>

      {Array.isArray(errors) && errors.length > 0
        ? Object.entries(
            errors?.reduce((acc, item) => {
              if (!acc[item.rowIndex]) {
                acc[item.rowIndex] = [];
              }
              acc[item.rowIndex].push(item.fieldName);
              return acc;
            }, {})
          ).map(([rowIndex, fields], idx) => (
            <Typography
              variant="body2"
              color="error"
              key={`error-${rowIndex}-${idx}`}
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
                marginTop: "0px",
              }}
            >
              Row {rowIndex} Missing fields: - {fields.join(", ")}
              {/* Row {rowIndex}: {fields.join(", ")} */}
            </Typography>
          ))
        : null}
    </Box>
  );
}

export default TableData;
